<svg
  [ngStyle]="styleList"
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 64 64"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    x="1.5"
    y="1.5"
    width="61"
    height="61"
    [attr.rx]="rx"
    fill="url(#paint0_linear_1102_1917)"
    stroke="#FEFEFE"
    stroke-width="3"
  />
  <mask
    id="path-2-inside-1_1102_1917"
    fill="white"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.3202 29.2031C12.1161 29.3924 12 29.6582 12 29.9366V44.9999C12 45.5522 12.4477 45.9999 13 45.9999H52C52.5523 45.9999 53 45.5522 53 44.9999V29.9366C53 29.6582 52.8839 29.3924 52.6798 29.2031L33.1798 11.13C32.7963 10.7745 32.2037 10.7745 31.8202 11.13L12.3202 29.2031ZM23 32C22.4477 32 22 32.4477 22 33V39C22 39.5522 22.4477 40 23 40H42C42.5523 40 43 39.5522 43 39V33C43 32.4477 42.5523 32 42 32H23Z"
    />
  </mask>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12.3202 29.2031C12.1161 29.3924 12 29.6582 12 29.9366V44.9999C12 45.5522 12.4477 45.9999 13 45.9999H52C52.5523 45.9999 53 45.5522 53 44.9999V29.9366C53 29.6582 52.8839 29.3924 52.6798 29.2031L33.1798 11.13C32.7963 10.7745 32.2037 10.7745 31.8202 11.13L12.3202 29.2031ZM23 32C22.4477 32 22 32.4477 22 33V39C22 39.5522 22.4477 40 23 40H42C42.5523 40 43 39.5522 43 39V33C43 32.4477 42.5523 32 42 32H23Z"
    fill="url(#paint1_linear_1102_1917)"
  />
  <path
    d="M12.3202 29.2031L11.6405 28.4697L11.6405 28.4697L12.3202 29.2031ZM52.6798 29.2031L52 29.9366L52 29.9366L52.6798 29.2031ZM33.1798 11.13L32.5 11.8634L32.5 11.8634L33.1798 11.13ZM31.8202 11.13L32.5 11.8634L32.5 11.8634L31.8202 11.13ZM13 29.9366L13 29.9366L11.6405 28.4697C11.2321 28.8482 11 29.3798 11 29.9366H13ZM13 44.9999V29.9366H11V44.9999H13ZM13 44.9999H13H11C11 46.1045 11.8954 46.9999 13 46.9999V44.9999ZM52 44.9999H13V46.9999H52V44.9999ZM52 44.9999V46.9999C53.1046 46.9999 54 46.1045 54 44.9999H52ZM52 29.9366V44.9999H54V29.9366H52ZM52 29.9366L52 29.9366H54C54 29.3798 53.7679 28.8482 53.3595 28.4697L52 29.9366ZM32.5 11.8634L52 29.9366L53.3595 28.4697L33.8595 10.3965L32.5 11.8634ZM32.5 11.8634L32.5 11.8634L33.8595 10.3965C33.0926 9.68569 31.9074 9.68569 31.1405 10.3965L32.5 11.8634ZM13 29.9366L32.5 11.8634L31.1405 10.3965L11.6405 28.4697L13 29.9366ZM23 33V31C21.8954 31 21 31.8954 21 33H23ZM23 39V33H21V39H23ZM23 39H21C21 40.1045 21.8954 41 23 41V39ZM42 39H23V41H42V39ZM42 39V41C43.1046 41 44 40.1045 44 39H42ZM42 33V39H44V33H42ZM42 33H44C44 31.8954 43.1046 31 42 31V33ZM23 33H42V31H23V33Z"
    fill="url(#paint2_linear_1102_1917)"
    mask="url(#path-2-inside-1_1102_1917)"
  />
  <defs>
    <linearGradient
      id="paint0_linear_1102_1917"
      x1="37.5"
      y1="64.0004"
      x2="-64.6232"
      y2="47.3419"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="white" />
      <stop
        offset="1"
        stop-color="#EBECF7"
      />
    </linearGradient>
    <linearGradient
      id="paint1_linear_1102_1917"
      x1="32.5"
      y1="10.8634"
      x2="-16.1848"
      y2="33.0132"
      gradientUnits="userSpaceOnUse"
    >
      <stop />
      <stop
        offset="1"
        stop-color="white"
      />
    </linearGradient>
    <linearGradient
      id="paint2_linear_1102_1917"
      x1="46.0662"
      y1="8.1606"
      x2="27.9276"
      y2="27.7534"
      gradientUnits="userSpaceOnUse"
    >
      <stop
        stop-color="white"
        stop-opacity="0"
      />
      <stop
        offset="0.428115"
        stop-color="white"
        stop-opacity="0.81428"
      />
      <stop
        offset="1"
        stop-color="white"
        stop-opacity="0"
      />
    </linearGradient>
  </defs>
</svg>
